import { render, staticRenderFns } from "./NewTicketDialog.vue?vue&type=template&id=b0e53b2e&"
import script from "./NewTicketDialog.vue?vue&type=script&lang=js&"
export * from "./NewTicketDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports